const OFFICE_MAP_LOCAL_CACHE_KEY_BASE = 'monsurv_office_map_settings_cache_v1';

export function getOfficeMapSettingsCacheKey(token) {
    let tenantSlug = 'iesis';
    try {
        const parts = String(token || '').split('.');
        if (parts.length >= 2) {
            const raw = parts[1].replace(/-/g, '+').replace(/_/g, '/');
            const padded = raw.padEnd(Math.ceil(raw.length / 4) * 4, '=');
            const payload = JSON.parse(atob(padded));
            tenantSlug = String(payload?.tenant_slug || '').trim().toLowerCase() || tenantSlug;
        }
    } catch {
        // Invalid or legacy tokens belong to the default tenant scope.
    }
    return `${OFFICE_MAP_LOCAL_CACHE_KEY_BASE}:${tenantSlug}`;
}

export function readOfficeMapSettingsCache() {
    try {
        const token = localStorage.getItem('monsurv_auth_token');
        const raw = localStorage.getItem(getOfficeMapSettingsCacheKey(token));
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}